import { render } from "./ListMaterial.vue?vue&type=template&id=59b5074d&scoped=true"
import script from "./ListMaterial.vue?vue&type=script&lang=js"
export * from "./ListMaterial.vue?vue&type=script&lang=js"

import "./ListMaterial.vue?vue&type=style&index=0&id=59b5074d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59b5074d"]])

export default __exports__